import { render, staticRenderFns } from "./liquidator-judicial-guard-form.vue?vue&type=template&id=246c74dd&scoped=true&"
import script from "./liquidator-judicial-guard-form.vue?vue&type=script&lang=js&"
export * from "./liquidator-judicial-guard-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246c74dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
